import * as React from "react";
import { ResponsiveBar } from '@nivo/bar';
import graphData from "../../assets/data/samplebardata";

export default class BarGraph extends React.Component {
  state = {};

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // actual data
  }

  render() {
    const { realData, indexBy, bottomLabel, leftLabel, labelNoRotate, showXAxis} = this.props;

    return (
      <div className="nivocontainer">
        <ResponsiveBar
          data={realData || graphData}
          keys={['score']}
          indexBy={indexBy || 'lesson'}
          margin={{ top: 50, right: 20, bottom: 40, left: 60 }}
          padding={0.2}
          groupMode="grouped"
          colors={{ scheme: 'nivo' }}
          colorBy="index"
          minValue={-10}
          maxValue={100}
          enableLabel={false}
          enableGridY={true}
          borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
          axisTop={null}
          axisRight={null}
          axisBottom={showXAxis ? {
            tickSize: 0,
            tickPadding: 8,
            tickRotation: labelNoRotate ? 0 : -25,
            legend: bottomLabel || 'Lessons',
            legendPosition: 'middle',
            legendOffset: 40
          }: null}
          axisLeft={{
            tickSize: 0,
            tickPadding: 2,
            tickRotation: 0,
            legend: leftLabel || 'Avg Score (%)',
            legendPosition: 'middle',
            legendOffset: -40
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          tooltip={(bar) => {
            return (
              <div
                style={{
                  padding: '4px',
                  backgroundColor: "#fff",
                  color: '#000',
                  borderRadius: '5px',
                  // width: "500px",
                  font: 'italic bold 15px Roboto Condensed'
                }}
              >
                <span><strong></strong>{bar.data[indexBy || 'lesson']}</span><br />
              </div>
            )
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/DataViz/bar.Component.js